export class QuestionBaseModel<T>{

    public value: T;    
    public onlineEnrollmentConfigurationId: number;
    // STAGELUID
    public stageLuid: number;
    // FIELDTYPENAME
    public fieldTypeName: string;
    // ROWNUMBER
    public rowNumber: number;
    // ColumnWidth
    public columnWidth: number;
    // ColumnPlacement
    public columnPlacement: number;
    // FIELDNAME
    public fieldName: string;
    // ISREQUIRED
    public isRequired: boolean;
    // LABEL
    public label: string;  
    // ISHIDDED
    public isHidded: boolean;
    // ORGANIZATIONID
   // public organizationId: number;

   // HELPTEXT
   public helpText:string;

   public maxLength:number;

  public validatorLuid:number;

  public validatorName:string;


    constructor(options: {
        value?:T,
        onlineEnrollmentConfigurationId?:number,
        stageLuid?:number,
        fieldTypeName?:string,
        rowNumber?:number,
        columnWidth?:number,
        columnPlacement?:number,
        fieldName?:string,
        isRequired?:boolean,
        label?:string,
        isHidded?:boolean,
        helpText?:string,
        maxLength?:number,
        validatorLuid?:number,
        validatorName?:string
      } = {}) {
        this.value=options.value;
        this.onlineEnrollmentConfigurationId=options.onlineEnrollmentConfigurationId;
        this.stageLuid=options.stageLuid;
        this.fieldTypeName=options.fieldTypeName;
        this.fieldName=options.fieldName;
        this.isRequired=options.isRequired;
        this.label=options.label;
        this.isHidded=options.isHidded;
        this.rowNumber=options.rowNumber;
        this.columnPlacement=options.columnPlacement;
        this.columnWidth=options.columnWidth;
        this.helpText=options.helpText;
        this.validatorLuid=options.validatorLuid;
        this.maxLength=options.maxLength;
        this.validatorName=options.validatorName;
    }
  }


// WEBPACK FOOTER //
// ./src/app/shared/models/question-base.model.ts